
<template>
  <!--Barra de mennú como componente-->
  <div>
  <NavBar></NavBar>
  <HireTalent></HireTalent>
  <HeadHunting></HeadHunting>
  <WhatFunction></WhatFunction>
  <PerfilJob></PerfilJob>
  <CardsText></CardsText>
  <ContainerDev></ContainerDev>
  <CardsDevs></CardsDevs>
  <router-view/>
  <QuestionsBar></QuestionsBar>
  <FooterBar></FooterBar>
 

  
</div>
</template>
<script setup>
import NavBar from '@/components/layouts/NavBar.vue'
import HireTalent from './components/HireTalent.vue';
import HeadHunting from './components/HeadHunting.vue';
import WhatFunction from './components/WhatFunction.vue';
import QuestionsBar from './components/layouts/QuestionsBar.vue';
import FooterBar from './components/layouts/FooterBar.vue';
import PerfilJob from './components/PerfilJob.vue'
import CardsText from './components/CardsText.vue';
import ContainerDev from './components/ContainerDev.vue';
import CardsDevs from './components/CardsDevs.vue';

import { onMounted } from 'vue';


onMounted(async()=>{
  try{
    const rawResponse = await fetch('https://www.gogodev.net/gogolearn/api/landings_company')
    const response = await rawResponse.json()
    console.log(response)
  }catch(e){
   console.log(e)
  }
})
</script>


<style>
@font-face {
  font-family: 'Darker Grotesque';
  src: url('~@/fonts/darker-grotesque.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}
</style>./components/layouts/HeroHead.vue
